RegistrableMixin = require '../mixins//registrable'
LICENSE_KEY = 'GPL'

RenderStyleElements = (editor) =>
	unsafeElements = editor.editing.view.domConverter.unsafeElements;
	indexOfStyle = unsafeElements.indexOf('style')
	if ( indexOfStyle > -1 ) 
		unsafeElements.splice( indexOfStyle, 1 )

_loader = null
_ctx = null

class SimpleUploadAdapter
  constructor: (loader, ctx) ->
    _loader = loader
    _ctx = ctx

  upload: ->
    new Promise (resolve, reject) ->
      data = new FormData()
      _loader.file.then (file) =>
        data.append "file", file

        fetch('https://smartomato.ru/api/organization_common_files', 
          method: 'POST',
          headers: 
            Authorization: "Token token=\"#{_ctx.get('session.apiKey')}\""
          body: data
        )
        .then (response) => response.json()
        .then (data) ->
          resolve(
            default: data.organization_common_file.file.url
          )
        .catch (err) ->
          reject "Upload failed"
    
  abort: ->
    # Optional abort logic4

class SimpleUploadAdapterPlugin
  # Define the required plugin
  @requires: ['FileRepository']

  constructor: (editor, ctx) ->
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) ->
      new SimpleUploadAdapter(loader, ctx)


App.RichTextEditorComponent = Em.Component.extend RegistrableMixin,
  session:     Em.inject.service()
  tagName: 'div'
  classNames: ['editor-container']
  ckeditorInstance: null
  loadDeferred: null

  didInsertElement: ->
    @retrieve().then (editorInstance) =>
      @initialize(@get('initialData'), @.$(), this)

  retrieve: ->
    if @get('loadDeferred')
      return @get('loadDeferred').promise

    deferred = Em.RSVP.defer()
    @set('loadDeferred', deferred)

    if @get('ckeditorInstance')
      deferred.resolve(@get('ckeditorInstance'))
      return deferred.promise

    interval = setInterval(() =>
      if window.CKEDITOR
        clearInterval(interval)
        @set('ckeditorInstance', window.CKEDITOR)
        deferred.resolve({
          initialize: @initialize,
          ctx: @
        })
    , 200)
    unless window.CKEDITOR
      Em.$.getScript("https://dynamic-island.smartomato.ru/ckeditor5.umd.js")
      Em.$.getScript("https://dynamic-island.smartomato.ru/translations/#{Em.I18n.locale}.umd.js")
    
    deferred.promise

  initialize: (data, element, ctx) ->
    editor = ctx.get('ckeditorInstance')
    classicEditor = editor.ClassicEditor
    editorConfig = {
      language: Em.I18n.locale,
      extraPlugins: [(editor) -> new SimpleUploadAdapterPlugin(editor, ctx)],
      allowedContent: true,
      toolbar: {
        items: [
          'sourceEditing',
          '|',
          'heading',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          '|',
          'bold',
          'italic',
          'underline',
          '|',
          'link',
          'insertImage',
          'insertTable',
          '|',
          'imageStyle:inline', 
          'imageStyle:wrapText', 
          'imageStyle:breakText', 
          '|',
          'toggleImageCaption', 
          'imageTextAlternative'
          '|',
          'alignment',
          '|',
          'bulletedList',
          'numberedList',
          'todoList',
          'outdent',
          'indent'
        ],
        shouldNotGroupWhenFull: false
      },
      plugins: [
        RenderStyleElements,
        editor.Alignment,
        editor.Autoformat,
        editor.AutoImage,
        editor.AutoLink,
        editor.Autosave,
        editor.Bold,
        editor.Bookmark,
        editor.Essentials,
        editor.FindAndReplace,
        editor.FontBackgroundColor,
        editor.FontColor,
        editor.FontFamily,
        editor.FontSize,
        editor.GeneralHtmlSupport,
        editor.Heading,
        editor.HorizontalLine,
        editor.ImageBlock,
        editor.ImageCaption,
        editor.ImageInline,
        editor.ImageInsert,
        editor.ImageInsertViaUrl,
        editor.ImageResize,
        editor.ImageStyle,
        editor.ImageTextAlternative,
        editor.ImageToolbar,
        editor.ImageUpload,
        editor.Indent,
        editor.IndentBlock,
        editor.Italic,
        editor.Link,
        editor.LinkImage,
        editor.List,
        editor.ListProperties,
        editor.PageBreak,
        editor.Paragraph,
        editor.RemoveFormat,
        editor.Strikethrough,
        editor.Table,
        editor.TableCaption,
        editor.TableCellProperties,
        editor.TableColumnResize,
        editor.TableProperties,
        editor.TableToolbar,
        editor.TextTransformation,
        editor.TodoList,
        editor.Underline,
        editor.SourceEditing
      ],
      htmlSupport: {
        allow: [            
          {
            name: /.*/, 
            attributes: true, 
            classes: true,
            styles: true,
          },
          {
            name: 'style', 
            styles: true,
          }
        ]
      },
      fontFamily: { supportAllValues: true },
      fontSize: { options: [10, 12, 14, 'default', 18, 20, 22], supportAllValues: true },
      initialData: data,
      licenseKey: LICENSE_KEY,
      link: {
        addTargetToExternalLinks: true,
        defaultProtocol: 'https://',
        decorators: {
          toggleDownloadable: {
            mode: 'manual',
            label: 'Downloadable',
            attributes: { download: 'file' }
          }
        }
      }
    }
    ctx = @
    classicEditor.create(element[0], editorConfig)
    .then (editor) -> ctx.set('editor', editor)
    .catch (error) -> console.error("Error initializing CKEditor:", error)